export { default } from './svg/add-fill.svg';
